/*jslint browser: true, devel:true */
/*global define*/
import $ from 'jquery';
import accountInfo from './account-info.js';
import notifications from './notifications.js';
import { eventType } from './config/settings.js';
import { sessionKey } from './store/cookies.js';
import { replace, push } from './store/history.js';


let mobile;
let mobileCountryCode;
const $myAccountSettings = $('.my-account-notifications');
const $verifyPhoneNumberWrapper = $('.js-verify_phone-number');
const $editPhoneNumberWrapper = $myAccountSettings.find('.js-edit_phone-number');
const $verifyCodeWrapper = $verifyPhoneNumberWrapper.find('.js-verify_code');
const $editPhoneNumberForm = $editPhoneNumberWrapper.find('form');
const $numberToVerifyCC = $verifyPhoneNumberWrapper.find('.phone-number-cc-to-verify');
const $numberToVerify = $verifyPhoneNumberWrapper.find('.phone-number-to-verify');
let data;


function updatePhone(number) {
	let deferred;
	if (sessionKey() && number) {
		deferred = $.ajax({
			url: '/player/phone',
			type: 'POST',
			data: JSON.stringify(number),
			contentType: 'application/json; charset=utf-8'
		});
	}

	return deferred;
}

function changePhoneNumber(changeMessage) {
	mobile = $editPhoneNumberForm.find("input[id='new-phone']").val();
	mobileCountryCode = $editPhoneNumberForm.find("input[id='new-phone-cc']").val();

	if (sessionKey()) {
		data = {
			mobile,
			mobileCountryCode
		};
		console.info(`init changePhoneNumber ${data.mobileCountryCode}${data.mobile}`);

		updatePhone(data).done((resultData) => {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				notifications.showNotification(changeMessage, 'green', true);
				$numberToVerify.text(mobile);
				$numberToVerifyCC.text(mobileCountryCode);
				$editPhoneNumberWrapper.removeClass('notify--is-open');
			}
			if (resultData.status === 'FAILURE') {
				notifications.showNotification(resultData.errorDescription, 'red', true);
				console.error(`Error changePhoneNumber ${resultData.errorDescription}. Code: ${resultData.errorCode}`);
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			console.error(jqXHR, textStatus, errorThrown);
		});
	}
}

function sendSMSVerifyPhoneNumber() {
	if (sessionKey()) {
		$.ajax({
			url: '/player/phone/verify/',
			type: 'POST',
			contentType: 'application/json; charset=utf-8'
		}).done((resultData) => {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				// Show green notification and display Verify Code screen
				push('/account/mysettings/verify-mobile/enter-code');
			}
			if (resultData.status === 'FAILURE') {
				//will this ever fail?
				notifications.showNotification(resultData.errorDescription, 'red', true);
				console.error(`Error sendSMSVerifyPhoneNumber ${resultData.errorDescription}. Code: ${resultData.errorCode}`);
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			console.error(jqXHR, textStatus, errorThrown);
		});
	}
}

function verifyPhoneNumber() {
	if (sessionKey()) {
		const code = $verifyCodeWrapper.find("input[id='new-code']").val();
		$.ajax({
			url: `/player/phone/verify/${code}`,
			type: 'GET',
			contentType: 'application/json; charset=utf-8'
		}).done((resultData) => {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				accountInfo.setVerificationNumber(true);
				push('/account/mysettings/verify-mobile/verified');
			}
			if (resultData.status === 'FAILURE') {
				console.error(`Error verifyPhoneNumber ${resultData.errorDescription}. Code: ${resultData.errorCode}`);
				push('/account/mysettings/verify-mobile/error');
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			console.error(jqXHR, textStatus, errorThrown);
		});
	}
}

function openVerifyCode() {
	sendSMSVerifyPhoneNumber();

}

function setMobileVerifyPageActive(bool) {
	// we want to make sure the first item shown is the info menu
	// not the code verification menu
	$verifyCodeWrapper.removeClass('notify--is-open');
	if (bool) {
		$myAccountSettings.addClass('my-account-notifications--is-open');
		$verifyPhoneNumberWrapper.addClass('notify--is-open');
		$verifyCodeWrapper.removeClass('notify--is-open');
		sendSMSVerifyPhoneNumber();
	} else {
		$myAccountSettings.removeClass('my-account-notifications--is-open');
		$verifyPhoneNumberWrapper.removeClass('notify--is-open');
	}
}

$('.js-verify-get-code').on('click.verifyPhone', () => {

	mobile = $verifyPhoneNumberWrapper.find("input[id='new-phone']").val();
	mobileCountryCode = $verifyPhoneNumberWrapper.find("input[id='new-phone-cc']").val();

	data = {
		mobile,
		mobileCountryCode
	};

	const phoneData = $verifyPhoneNumberWrapper.data();

	accountInfo.fetchPlayerInfo().then((resultData) => {
		if (resultData.status === 'SUCCESS') {
			if (sessionKey() && !(data.mobile === phoneData.mobile && data.mobileCountryCode === phoneData.mobileCountryCode)) {
				updatePhone(data)
					.done((resultData) => {
						if (resultData.status === 'SUCCESS' && resultData.result) {
							openVerifyCode();
						}
						if (resultData.status === 'FAILURE') {
							notifications.showNotification(resultData.errorDescription, 'red', true);
						}
					});

			} else {
				openVerifyCode();
			}
		}
	});
});

// Account setting mobile number
// opens the modal window for verify phone number
// we no longer need this event
// navigation directs the user to verify_number page

// open verify number
$verifyPhoneNumberWrapper.find('.js-edit_verifymobile').on(eventType, () => {
	$verifyCodeWrapper.addClass('notify--is-open');
	return false;
});

// open edit phone number
$verifyPhoneNumberWrapper.find('.js-editphone').on(eventType, () => {
	$editPhoneNumberWrapper.addClass('notify--is-open');
	return false;
});

// change phone number
$editPhoneNumberWrapper.find('.js-changephone').on(eventType, function () {
	const changeMessage = $(this).data('message');
	changePhoneNumber(changeMessage);
	return false;
});

// send sms
$verifyPhoneNumberWrapper.find('.js-resendsms').on(eventType, function () {
	sendSMSVerifyPhoneNumber();
	return false;
});


// verify number
$verifyCodeWrapper.find('.js-verifymobile').on(eventType, function () {
	verifyPhoneNumber();
	return false;
});

// TODO REMOVE THIS CLICKHANDLERS AND ADD THEM TO ROUTER.JS WHEN NAVIGATION IS COMPLETED
$verifyPhoneNumberWrapper.find('.js-icon-close').on(eventType, () => {
	// we use window.history.back because we will allow users to enter the mobile verification flow from any other flow
	// therefore we want users to be able to go back to where they came from when they close this menu


	replace('/account');
});

$editPhoneNumberWrapper.find('.js-icon-close').on(eventType, function () {
	$(this).parent().removeClass('notify--is-open');
	return false;
});

$verifyCodeWrapper.find('.js-icon-close').on(eventType, () => {
	$myAccountSettings.removeClass('notify--is-open');
	replace('/account');
	//push('/account');
	return false;
});

export default {
	changePhoneNumber,
	sendSMSVerifyPhoneNumber,
	verifyPhoneNumber,
	setMobileVerifyPageActive
};




// WEBPACK FOOTER //
// ./mobile-core/src/account-settings-mobile-number.js